@if (order$ | async; as order) {
  <div class="cx-page-header">
    <span class="cx-page-title">
      {{ 'AtgOrderConfirmation.confirmationOfOrder' | cxTranslate }}
      {{ $any(order).replenishmentOrderCode ?? order.purchaseOrderNumber }}
    </span>
  </div>
  <div class="cx-order-confirmation-message">
    <h2>{{ 'AtgOrderConfirmation.thankYou' | cxTranslate }}</h2>
  </div>
}
